import {ActionIcon, createStyles, Group, Select} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export interface PlateNavigatorProps {
  totalPlates: number;
  currentIndex: number;
  onChangeIndex: (index: number) => void;
}

const useStyles = createStyles((theme) => ({
  plateNavigator: {
    marginBottom: theme.spacing.xs,
  },
}));

export default function PlateNavigator({
  totalPlates,
  currentIndex,
  onChangeIndex,
}: PlateNavigatorProps): JSX.Element {
  const {classes} = useStyles();
  const plateSelectData = Array.from({length: totalPlates}, (_, i) => ({
    value: String(i),
    label: `Plate ${i + 1} of ${totalPlates}`,
  }));
  const isDisabled = totalPlates <= 1;

  return (
    <Group spacing="xs" className={classes.plateNavigator}>
      <ActionIcon
        size="sm"
        variant="subtle"
        aria-label="Previous plate"
        disabled={isDisabled || currentIndex === 0}
        onClick={() => {
          onChangeIndex(currentIndex - 1);
        }}
      >
        <BenchlingIcon icon="chevron-left" />
      </ActionIcon>
      <Select
        aria-label="Select plate"
        data={plateSelectData}
        value={String(currentIndex)}
        disabled={isDisabled}
        allowDeselect={false}
        onChange={(value) => {
          if (value != null) {
            onChangeIndex(Number(value));
          }
        }}
      />
      <ActionIcon
        size="sm"
        variant="subtle"
        aria-label="Next plate"
        disabled={isDisabled || currentIndex === totalPlates - 1}
        onClick={() => {
          onChangeIndex(currentIndex + 1);
        }}
      >
        <BenchlingIcon icon="chevron-right" />
      </ActionIcon>
    </Group>
  );
}
